import 'bootstrap'
import 'bootstrap/dist/css/bootstrap.css';
import '@fortawesome/fontawesome-free/scss/fontawesome.scss'
import '@fortawesome/fontawesome-free/scss/solid.scss'
import 'core-js'
import 'lity/dist/lity.js'
import 'lity/dist/lity.css'

import './parts/swiper'
import './parts/header'
import './parts/lightgallery'
import './parts/footer'
import './parts/wrote-about'
import $ from 'jquery';


const csbwrap = document.getElementsByClassName("csb-wrap");
if(csbwrap){
  Array.prototype.forEach.call(csbwrap,function(csb){
    const yes = csb.childNodes[2];
    const no = csb.childNodes[5];
    let money = "Ft";
    yes.addEventListener("change", (event) => {
      if (event.target.checked) {
        csb.nextSibling.nextSibling.querySelector(".variation_id").value=yes.id;
        csb.nextSibling.nextSibling.querySelector(".woocommerce-Price-amount").textContent=yes.classList[0]+" "+money;
      } else {
        csb.nextSibling.nextSibling.querySelector(".variation_id").value=no.id;
        csb.nextSibling.nextSibling.querySelector(".woocommerce-Price-amount").textContent=no.classList[0]+" "+money;
      }
    });
  })
}

const food = document.getElementById("food-cat");
if(food){
  food.addEventListener("change",(event)=>{
    if(event.target.value === "all"){
      Array.prototype.forEach.call(document.getElementsByClassName("food"),function(fd){
        fd.classList.remove("d-none");
      });
    }
    else{
      Array.prototype.forEach.call(document.getElementsByClassName("food"),function(fd){
        if(fd.id != event.target.value){
          fd.classList.add("d-none");
        }
        else{
          fd.classList.remove("d-none");
        }
      });
    }
  })
}

const drink = document.getElementById("drink-cat");
if(drink){
  drink.addEventListener("change",(event)=>{
    if(event.target.value === "all"){
      Array.prototype.forEach.call(document.getElementsByClassName("drink"),function(fd){
        fd.classList.remove("d-none");
      });
    }
    else{
      Array.prototype.forEach.call(document.getElementsByClassName("drink"),function(fd){
        if(fd.id != event.target.value){
          fd.classList.add("d-none");
        }
        else{
          fd.classList.remove("d-none");
        }
      });
    }
  })
}

const etlap = document.getElementById("etlap-visible");
if(etlap){
  etlap.addEventListener("click",(event)=>{
    event.target.classList.add("active");
    document.getElementById("itallap-visible").classList.remove("active");
    document.getElementById("etlap").classList.remove("d-none");
    document.getElementById("itallap").classList.add("d-none");
  })
}

const itallap = document.getElementById("itallap-visible");
if(itallap){
  itallap.addEventListener("click",(event)=>{
    event.target.classList.add("active");
    document.getElementById("etlap-visible").classList.remove("active");
    document.getElementById("etlap").classList.add("d-none");
    document.getElementById("itallap").classList.remove("d-none");
  })
}

let termek = document.getElementsByClassName("product");
if(termek){
  Array.prototype.forEach.call(termek,function(t){
    if(t.querySelector(".button")==null && document.body.classList[1]!="page-template-template-napi-menu"){
      
      let p = document.createElement("p");
      p.classList.add("nocart");
      let txt = document.createTextNode(object_name.csakhelyben);
      p.appendChild(txt);
      t.appendChild(p);
    }
  })
}
let ctcb = document.getElementById("ctcb");
if(ctcb){
  ctcb.textContent = object_name.ctcb;
  document.querySelector("#ctcb").addEventListener("click", copy);
}

function copy() {
  var copyText = document.querySelector("#ctcb-email");
  copyText.select();
  document.execCommand("copy");
}

let billcity = document.getElementById("billing_city_custom");
if(billcity){
  billcity.addEventListener("change",(event)=>{
    let zip = document.getElementById("billing_postcode");
    console.log(event)
    zip.value = event.target.value;
  })
}

/*
jQuery('.shipping_address').css('display','block');

var bigHtml = jQuery(".woocommerce-billing-fields").children().not("h3, .create-account").detach();
var smallHtml = jQuery('.shipping_address').detach();
jQuery('.woocommerce-billing-fields').append(smallHtml);
jQuery('.woocommerce-shipping-fields').append(bigHtml);
//jQuery('#order_comments_field').before(bigHtml);

jQuery('.woocommerce-billing-fields h3').text('Shipping Details');
jQuery('h3#ship-to-different-address').replaceWith('<h3 id="ship-to-billing-different-address"><label for="ship-to-billing-different-address-checkbox" class="checkbox">Számlázás másik címre?</label><input id="ship-to-billing-different-address-checkbox" class="input-checkbox" name="ship_to_different_billing_address" value="1" type="checkbox"></h3>');
jQuery(".woocommerce-shipping-fields").children().not("h3,#order_comments_field").hide();
*/
if(jQuery("#ship-to-billing-different-address-checkbox")){
  jQuery("#ship-to-billing-different-address-checkbox").click(function(event) {
    if (jQuery(this).is(":checked")){
      jQuery(".woocommerce-shipping-fields").children().not("h3,#order_comments_field").show();
      //jQuery("#shipping_postcode_field").children().not("span").detach();
      //jQuery("#shipping_postcode_field").append(jQuery("#shipping_city_field label"));
      console.log(jQuery("#shipping_postcode_field"));
    }
    else
      jQuery(".woocommerce-shipping-fields").children().not("h3,#order_comments_field").hide();
  });
}

if(jQuery("#billing_postcode")){
  jQuery("#billing_postcode").change((e)=>{
    jQuery("#shipping_postcode").val(jQuery( "#billing_postcode option:selected" ).val());
    let g = jQuery('#ship-to-different-address-checkbox')
    g.trigger('click')
    g.trigger('click')
  })
}
/*
window.addEventListener('DOMContentLoaded', () => {
  let datHack = document.querySelector("label[for=billing_postcode]");
  if(datHack){
    datHack.textContent = object_name.postcode;
  }
})*/
